import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import { Avatar } from "@material-ui/core";
import doctor from "../assets/doctor.svg";
import clinician from "../assets/clinician.svg";
import appointment from "../assets/appointment.svg";
import send2Pass from "../assets/send2Pass.svg";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { DateTime } from "luxon";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: "6px 16px"
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

const calculateTime = dateString => {
  const dateObj = new Date(dateString);

  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();

  // Convert hours to 12-hour format
  const displayHours = hours > 12 ? hours - 12 : hours;

  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";

  // Construct the final time string
  const timeString = `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;

  return timeString;
};

const calculateDate = dateString => {
  const dateObj = new Date(dateString);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const month = months[dateObj.getMonth()];
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();

  const formattedDate = `${month} ${day}, ${year}`;

  return formattedDate;
};

const TimeLineItem = ({ date, time, icon, clinicianName, actionHeading, actionDesc }) => {
  const classes = useStyles();

  const getActionDescAsArray = () => {
    const arr = actionDesc instanceof Array
        ? actionDesc
        : actionDesc?.trim()?.split('\\n');
    for(let i = 0; i < arr.length; i++){
      arr[i] = arr[i].trim();
    }
    return arr;
  }

  return (
    <>
      <Typography variant="body2" color="textSecondary" className="timeTitle">
        {date}
      </Typography>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineConnector />
          <Typography variant="body2" color="textSecondary" className="timeText">
            {time}
          </Typography>
          <TimelineDot className="timelineImg">
            <Avatar className="timeLineAvatar" variant="square" src={icon} />
          </TimelineDot>
          <TimelineConnector className="connectorBottom" />
        </TimelineSeparator>
        <TimelineContent className="timelineInfo">
          <Row>
            <Col className="infoCol">
              <Avatar className="timeLineAvatar" alt="Remy Sharp" src={doctor} />
            </Col>
            <Col className="infoContent">
              <Typography className="timeLineHead"> {clinicianName} </Typography>
              {/* <Typography className="timeLineSubHead">APRN-CNP</Typography> */}
            </Col>
          </Row>
        </TimelineContent>
        <TimelineOppositeContent className="timelineContent">
          <Paper elevation={3} className={classes.paper} id="timeLinePaper">
            {/*<Typography className="timeLineSubHead">{actionDesc}</Typography>*/}
            {getActionDescAsArray()?.map((item, index) => (
                <Typography key={index} className="timeLineSubHead">
                  {item}
                </Typography>
            ))}
          </Paper>
        </TimelineOppositeContent>
      </TimelineItem>
    </>
  );
};

const PatientHistory = ({ data, isDateInEpoch }) => {

  return (
    <>
      <Row className="TimelineRow">
        <Col>
          <Timeline align="left">
            {data()?.map((item, index) => {
              return (
                <TimeLineItem
                  date={isDateInEpoch ? DateTime.fromMillis(item?.createdEpoch * 1000).toFormat("LLLL dd, yyyy") : calculateDate(item?.created)}
                  time={isDateInEpoch ? DateTime.fromMillis(item?.createdEpoch * 1000).toFormat("hh:mm a") : calculateTime(item?.created)}
                  icon={clinician}
                  clinicianName={item?.authorName || ""}
                  actionHeading="Patient Re-Assigned"
                  actionDesc={item?.note || ""}
                />
              );
            })}
          </Timeline>
        </Col>
      </Row>
    </>
  );
};

export default PatientHistory;
